import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react'

const options = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    opt_out_capturing_by_default: process.env.REACT_APP_POSTHOG_ENABLED !== 'true'
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY?.toString() || '';

root.render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={posthogKey}
            options={options}
        >
            <App />
        </PostHogProvider>
        <audio id="notification-audio-player" src="/notification-sound.mp3" loop={false} controls={false} style={{display: "none"}} />
    </React.StrictMode>
);